import { type SlideDTO, SlideEntityType } from './type.d'

export const slideMock: SlideDTO[] = [
  {
    id: 11,
    posterImage: 'https://placehold.co/640x360',
    mobilePosterImage: 'https://placehold.co/360x640',
    entity: {
      type: SlideEntityType.event,
      object: {
        id: 11,
        title:
          'Концерт группы "Ария" 23q1 asd asd o390 u3r bnwer9087234 hfb se98r wfbk sdf98 rbk sdfsd9 8fsdibf sd98f sdfbksd98f ikb sfsdf97u sdkfbsd9f kbdsf 908sdfhbksdljf 09sdf usdkb f',
        venue: 'Крокус Сити Холл',
        price: 2500,
        date: '2024-03-15T19:00:00.000Z',
        ageCategory: '16+',
        category: 'Концерт'
      }
    }
  },
  {
    id: 22,
    posterImage: 'https://placehold.co/640x360',
    mobilePosterImage: 'https://placehold.co/360x640',
    entity: {
      type: SlideEntityType.event,
      object: {
        id: 12,
        title: 'Балет "Лебединое озеро"',
        venue: 'Большой театр',
        price: 3500,
        date: '2024-03-20T19:30:00.000Z',
        ageCategory: '6+',
        category: 'Концерт'
      }
    }
  },
  {
    id: 33,
    posterImage: 'https://placehold.co/640x360',
    mobilePosterImage: 'https://placehold.co/360x640',
    entity: {
      type: SlideEntityType.event,
      object: {
        id: 13,
        title: 'Выставка "Импрессионисты"',
        venue: 'Третьяковская галерея',
        price: undefined,
        date: '2024-03-25T10:00:00.000Z',
        ageCategory: '0+',
        category: 'Концерт'
      }
    }
  },
  {
    id: 44,
    posterImage: 'https://placehold.co/640x360',
    mobilePosterImage: 'https://placehold.co/360x640',
    entity: {
      type: SlideEntityType.event,
      object: {
        id: 14,
        title: 'Спектакль "Гамлет"',
        venue: 'МХТ им. Чехова',
        price: 1800,
        date: '2024-04-01T19:00:00.000Z',
        ageCategory: '12+',
        category: 'Концерт'
      }
    }
  },
  {
    id: 55,
    posterImage: 'https://placehold.co/640x360',
    mobilePosterImage: 'https://placehold.co/360x640',
    entity: {
      type: SlideEntityType.event,
      object: {
        id: 15,
        title: 'Джазовый концерт',
        venue: 'Дом музыки',
        price: 2200,
        date: '2024-04-05T20:00:00.000Z',
        ageCategory: '16+',
        category: 'Концерт'
      }
    }
  }
]
